// src/components/layout/LayoutWrapper.tsx
import React from "react";

interface LayoutWrapperProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

/**
 * LayoutWrapper is a structural wrapper used to
 * give every page a consistent max-width, padding,
 * and background context. It also supports custom styling.
 */
const LayoutWrapper: React.FC<LayoutWrapperProps> = ({
  children,
  className = "",
  id,
}) => {
  return (
    <div
      id={id}
      className={[
        "w-full mx-auto max-w-6xl px-4 sm:px-6 lg:px-8",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </div>
  );
};

export default LayoutWrapper;
